export default __webpack_public_path__ + "static/media/sima.add2af16.png";